import styled from "styled-components"

import {PADDING} from "../constants"

interface StyledProps {
  size: number,
  isSet: boolean
}

const StyledImg = styled<StyledProps, "img">("img")`
  position: absolute;
  top: ${PADDING / 2}px;
  left: ${PADDING / 2}px;
  right: ${PADDING / 2}px;
  bottom: ${PADDING / 2}px;
  ${({size, isSet}) => `
    ${!isSet && "opacity: 0.3;"}
    max-width: ${size - PADDING}px;
    max-height: ${size - PADDING}px;
  `}
  max-height: calc(100% - ${PADDING}px);
  max-width: calc(100% - ${PADDING}px);
`

export default StyledImg
